// 1.Start of Eliran code : Add all this Variables to the head of the doc
var id = [];
var isBaseIn = false;
var isDockIn = false;
var numOfTops = 5;
var atLeastOneTop = false;
var is484 = false;
var numOfDocks = 0;
var numOfTopsmDocks = numOfDocks * numOfTops;
var docks = "";
var isPack = false;
// End of Eliran code

var SessionStorage = {
    getItem: function (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ')
                c = c.substring(1);
            if (c.indexOf(name) == 0)
                return c.substring(name.length, c.length);
        }
        return JSON.stringify(new Array());
    }
    , setItem: function (cname, cvalue) {
        var d = new Date();
        d.setTime(d.getTime() + (2 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
    }
};


(function ($) {
    var re = /([^&=]+)=?([^&]*)/g;
    var decodeRE = /\+/g; // Regex for replacing addition symbol with a space
    var decode = function (str) {
        return decodeURIComponent(str.replace(decodeRE, " "));
    };
    $.parseParams = function (query) {
        var params = {}, e;
        while (e = re.exec(query)) {
            var k = decode(e[1]), v = decode(e[2]);
            if (k.substring(k.length - 2) === '[]') {
                k = k.substring(0, k.length - 2);
                (params[k] || (params[k] = [])).push(v);
            }
            else
                params[k] = v;
        }
        return params;
    };
})(jQuery);

function checkAlreadyExist(items, pid) {
    var isfound = -1;
    for (var key in items) {
        if (items[key]['id'] == pid)
        {
            isfound = key;
            break;
        }
    }
    return isfound;
}

function storedata(pid, q, p, n, gim, catid) {
    if (typeof (Storage) !== "undefined") {
        var items = JSON.parse(SessionStorage.getItem("items"));
        if (items == null || items == '') {
            items = new Array();
        }
        var isexist = checkAlreadyExist(items, pid);

        if (isexist == -1) {
            items.push({id: pid, q: q, p: p, n: n, gim: gim, catid: catid});
        }
        else {
            if (q == 0)
                delete items[isexist];
            items[isexist] = {id: pid, q: q, p: p, n: n, gim: gim, catid: catid};
        }
        SessionStorage.setItem("items", JSON.stringify(items));

    } else {
        alert("Your browser is old and is not supporting the functionality of the website.");
    }
}

$(document).ready(function () {
    
    $.ajax({
        url: "/cart.js",
        dataType: "json",
        success: function (data) {
            var items = new Array();
            var cart_items = data["items"];
            for (var key in cart_items) {
                items.push({id: cart_items[key].id, q: cart_items[key].quantity, p: (cart_items[key].price / 100), n: cart_items[key].product_title});
            }
            SessionStorage.setItem("items", JSON.stringify(items));
            displayit(JSON.parse(SessionStorage.getItem("items")));
            // 2. Eliran Code : Add this line, updates cartStatus
            cartStatus(JSON.parse(SessionStorage.getItem("items")));
            // End of Eliran Code
        }
    });



    function scrolling() {
        var a = 330/*$(".banner-section").outerHeight()*/;
        var pos = $(window).scrollTop();
        if (pos > a) {
            $("body").addClass("header-out");
        }
        else {
            $("body").removeClass("header-out");
        }
    }
    scrolling();
    $(window).scroll(scrolling);

    $(".res-ico").click(function () {
        $(".h-menu").toggleClass("h-menu-show");
        return false;
    });

    $('.accordin_title').click(function (ev) {
        ev.preventDefault();
        var selector = $(this);
        var item_parent = selector.parents('.faq-item');
        var content = item_parent.find('.faq-a');

        item_parent.toggleClass('active');
        var content_height = content.css('height');
        content.css('height', 'auto');
        var content_a_height = content.css('height');
        content.css('height', content_height);

        if (item_parent.hasClass('active')) {
            $(content).animate({
                height: content_a_height
            }, 300, function () {
                $(this).addClass('preview-active');
            });
        }
        else {
            $(content).animate({
                height: 20
            }, 300, function () {
                $(this).removeClass('preview-active');
            });
        }
        return false;
    });

  
  
  
  
  //Ruben added
  
    $('.faq-a').click(function (ev) {
        ev.preventDefault();
        var selector = $(this);
        var item_parent = selector.parents('.faq-item');
        var content = item_parent.find('.faq-a');

        item_parent.toggleClass('active');
        var content_height = content.css('height');
        content.css('height', 'auto');
        var content_a_height = content.css('height');
        content.css('height', content_height);

        if (item_parent.hasClass('active')) {
            $(content).animate({
                height: content_a_height
            }, 300, function () {
                $(this).addClass('preview-active');
            });
        }
        else {
            $(content).animate({
                height: 20
            }, 300, function () {
                $(this).removeClass('preview-active');
            });
        }
        return false;
    });
  
  
  
  
  
    $('#client-logo-slider').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 6,
        arrows: false,
        slidesToScroll: 6,
        rows: 2,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]

    });

    $(document).ready(function () {
        $(".clients-logo").show();
    });



    $('.h-menu a[href*=#]:not([href=#]), .main-menu a[href*=#]:not([href=#])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {

            var target = jQuery(this.hash);
            target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                jQuery('html,body').animate({
                    scrollTop: target.offset().top - parseFloat(48)
                }, 1000);
                return false;
            }
        }
    });



    $(".imagegallery").each(function () {
        $(this).magnificPopup({
            delegate: 'a.popup',
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    });
    $("a.video").each(function () {
        $(this).magnificPopup({
            type: 'iframe'
        });
    });
    $('#gallery').magnificPopup({
        delegate: 'a.imagelink', // the selector for gallery item
        type: 'image'
    });

    function refreshitembox() {
        $('.price-box').each(function () {
            var selector = $(this);
            var pid = selector.find('.qminus').data('id');
            ;
            var items = JSON.parse(SessionStorage.getItem("items"));
            var isexist = checkAlreadyExist(items, pid);
            if (isexist != -1) {
                var q = items[isexist]['q'];
                selector.find('.qquan').html(q);
            }
        });
    }
    refreshitembox();

    $(".qplus").on("click", function () {
        var quant = $(this).parent().find(".qquan");
        var qant = parseInt(quant.html());
        var gim = $(this).data("img-src");
        var catid = $(this).data("cat-id");

        quant.html(qant + 1);
        var name = $(this).parent().parent().parent().find(".product-title").html().trim();
        var price = parseInt($(this).parent().parent().find(".pb-price").html().trim().substr(1));
        storedata($(this).data("id"), qant + 1, price, name, gim, catid);

        var items = JSON.parse(SessionStorage.getItem("items"));
        // 3. Eliran Code : Add this line, updates cartStatus
        cartStatus(items);
        // End of Eliran code
        displayit(items);
        updatecart();
    });
    $(".qminus").on("click", function () {
        var quant = $(this).parent().find(".qquan");
        var qant = parseInt(quant.html());
        var gim = $(this).data("img-src");
        var catid = $(this).data("cat-id");

        if (qant >= 1) {
            quant.html(qant - 1);
            var name = $(this).parent().parent().parent().find(".product-title").html().trim();
            var price = parseInt($(this).parent().parent().find(".pb-price").html().trim().substr(1));
            storedata($(this).data("id"), qant - 1, price, name, gim, catid);
            var items = JSON.parse(SessionStorage.getItem("items"));
            // 4. Eliran Code : Add this line, updates cartStatus
            cartStatus(items);
            // End of Eliran code
            displayit(items);
            updatecart();
        }
    });

    $(".product-rows").on("click", ".qplus", function () {
        var quant = $(this).parent().find(".qquan");
        var qant = parseInt(quant.html());
        var gim = $(this).data("img-src");
        var catid = $(this).data("cat-id");

        quant.html(qant + 1);
        var name = $(this).parent().parent().parent().find(".product-title").html().trim();
        var price = parseInt($(this).parent().parent().parent().find(".pb-price").html().trim().substr(1));
        storedata($(this).data("id"), qant + 1, price, name, gim, catid);
        var items = JSON.parse(SessionStorage.getItem("items"));
        // 5. Eliran Code : Add this line, updates cartStatus
        cartStatus(items);
        // End of eliran code
        displayit(items);
        updatecart();
    });
    $(".product-rows").on("click", ".qminus", function () {
        var quant = $(this).parent().find(".qquan");
        var qant = parseInt(quant.html());
        var gim = $(this).data("img-src");
        var catid = $(this).data("cat-id");

        if (qant >= 1) {
            quant.html(qant - 1);
            var name = $(this).parent().parent().parent().find(".product-title").html().trim();
            var price = parseInt($(this).parent().parent().parent().find(".pb-price").html().trim().substr(1));
            storedata($(this).data("id"), qant - 1, price, name, gim, catid);
            if (qant - 1 == 0) {
                $(this).parent().parent().parent().remove();
            }
            var items = JSON.parse(SessionStorage.getItem("items"));
            // 6. Eliran Code : Add this line, updates cartStatus
            cartStatus(items);
            // End of code
            displayit(items);
            updatecart();
        }
    });

    var cats = new Array();
    function is_cat_already_exist(pid) {
        var isfound = -1;
        for (key in cats) {
            if (cats[key]['id'] == pid)
            {
                isfound = key;
                break;
            }
        }
        return isfound;
    }
    // 7. Start of Eliran code : Add this code to the file, it includes the displayit() function so replace it until the endofcode comment.
    var topIds = [
        6634482884,
        6634492868,
        6634483140,
        6634486020,
        6634483076,
        10100786564,
        6634483652,
        6634492548,
        6634492740,
        6634487044,
        6634487108,
        6634482948,
        6634492484,
        6634487236,
        6634492420,
        20133511172,
        20133439108,
        20133564932,
        20133521156,
      	13054342135861,
      	20133488836,
      	15241204203573,
      	33287715094581,
      	32129468989493,
      	39709812621365,
      	33437626499125,
      	40206691958837,
        44154575290421
        
      
    ];
    
    
    function cartStatus(items) {
    numOfTopsIn = 0;
    isBaseIn = false;
    isDockIn = false;
    atLeastOneTop = false;
    isPopular = false;
    numOfDocks = 0;
    docks = "";
    isPack = false;
    for(var n in items) {
        if(items[n] && items[n].q > 0) {
            var c = items[n].id;
            for(var i = 0; i < topIds.length;i++) {
                if(c === 6634492484){
                    isPopular = true;
                }
                if(c === topIds[i]) {
                  var q = items[n].q;
                  var tot = 0;
                  tot = tot + q;
                  numOfTopsIn += tot;
                };
            }
        } 
    } 
    for(var n in items) {
        if (items[n] && items[n].q > 0){            
            var c = items[n].id;
            console.log(items[n].id);
            if(c === 6634492292 || c === 21877122692 || c === 21877132548 || c === 39241329992 || c === 39238882504 || c === 39482797320 || c === 37734709512 || c === 28726141747253 || c === 28726145089589 || c === 28726145941557 || c === 31437930823733 || c === 31440035446837 || c === 31440012345397 || c === 31464507179061 || c === 33341461921845 || c === 33354515480629 ) {
                isBaseIn = true;
            }
            if(c === 6634492100 || c === 6634492164 || c === 6634492036 || c === 31440162062389 || c === 33343084560437 || c ===40206991687733) {
                isDockIn = true;
                numOfDocks += items[n].q;
                if(numOfDocks > 1) {
                    docks = "s"
                }
                numOfTopsmDocks = numOfDocks * 5;
                numOfTops = numOfTopsmDocks;
                numOfTops -= numOfTopsIn;
                if(numOfTops < 0) {
                    numOfTops = 0;
                }
            }
            if( c === 6634490436 || c === 6634488132 || c === 6634487812 || c === 31464507179061) {
                isPack = true;
                docks = "s";
            }
        }
    }
}

    

 function displayit(data) {
        var html = "";
        var quan = "";
        var total = sum = 0;
        var cart = "";

        for (var n in data) {
            if (data[n] && data[n].q > 0) {
                html += '<div class="clearfix"><div class="col-sm-6 product-title">' + data[n].n + '</div>';
                html += '<div class="col-sm-2 pb-price">$' + data[n].p + '</div>';
                html += '<div class="col-sm-2"><div class="quantity">';
                html += '<span class="qminus" data-id="' + data[n].id + '" data-img-src="' + data[n].gim + '" data-cat-id="' + data[n].catid + '"><i class="fa fa-minus"></i></span>';
                html += '<span class="qquan">' + data[n].q + '</span>';
                html += '<span class="qplus" data-id="' + data[n].id + '" data-img-src="' + data[n].gim + '" data-cat-id="' + data[n].catid + '"><i class="fa fa-plus"></i></span>';
                html += '</div><input type="hidden" id="updates_' + data[n].id + '" name="updates[]"value="' + data[n].q + '" pattern="[0-9]*" aria-label="quantity" data-id=""  class="js-qty__num"></div>';
                html += '<div class="col-sm-2"><a data-id="' + data[n].id + '" class="removeit" href="javascript:void(0);">Remove</a></div></div>';
                total += data[n].p * data[n].q;
                sum += parseInt(data[n].q);
                cart += '<div class="cart">';
                cart += '</div>';
            }

            refreshitembox();
        }

        if (sum > 0) {
            $("#gotocheckout").addClass("active");
        } else {
            $("#gotocheckout").removeClass("active");
        }
        var text = $(".total-price").text();
      
    
      
        var shipping = (89 - (total * 0.80)).toFixed(2);  

        if ((total * 0.80) < 89 && sum <= 0) {
            $(".freeshipingtext").css("display", "none");
            $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'><a class='addtb' href='#'><img class='imgside topandbase' src='//foreverspin.com/cdn/shop/t/69/assets/stb_compact.png?v=40406547779130519831763937063' alt='top'></a> Spend <strong>$" + shipping + " more</strong> for free shipping<br/><a class='addtb' href='#'><u>Add most popular Top and Base</u></a></span>");
        } else if ((total * 0.80) < 89) {
            $(".freeshipingtext").css("display", "none");
           if (!isBaseIn) {
                $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'><a class='addb' href='#'><img class='imgbase' src='//foreverspin.com/cdn/shop/t/69/assets/base_compact.png?v=154929293532905114701763936993' alt='top'></a> Spend <strong>$" + shipping + " more</strong> for free shipping<br/><a class='addb' href='#'><u>We recommend the spinning base!</u></a></span>");
            } else if(!isPopular) {
            $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'><a class='addt' href='#'><img class='imgside' src='//foreverspin.com/cdn/shop/t/69/assets/tinobg_small.png?v=2575924051852192451763937065' alt='top'></a> Spend <strong>$" + shipping + " more</strong> for free shipping<br/><a class='addt' href='#'><u>Add our most popular Top</u></a></span>");    
            } else{
                $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'> Spend <strong>$" + shipping + " more</strong> for free shipping<br/></span>");
            }
        } else if ((total * 0.80) >= 89) {
            $( ".cart_quantity .cart_empty" ).empty();
            $(".freeshipingtext").css("display","block");
            if (!isBaseIn) {
                $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'><a class='addb' href='#'><img class='imgbase' src='//foreverspin.com/cdn/shop/t/69/assets/base_compact.png?v=154929293532905114701763936993' alt='top'>Add our famous <strong>ForeverBase&trade;</strong><br/><u>Click to add base!</u></a></span>");
            } else {
            if(!isDockIn && numOfTopsIn > 2 && !isPack) {
                $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'><a class='addd' href='#'><img class='imgside' src='//foreverspin.com/cdn/shop/t/69/assets/ssds_compact.png?v=64711539300718695981763937062' alt='top'>Display with <strong>ForeverDock&trade;</strong><br><u>Click to add Dock</u></a></span>");
            }  else if(isPack && numOfTopsIn > 2 && !isDockIn) {
                $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'><a class='addd' href='#'><img class='imgside' src='//foreverspin.com/cdn/shop/t/69/assets/ssds_compact.png?v=64711539300718695981763937062' alt='top'>Perhaps another <strong>ForeverDock&trade;</strong><br><u>Click to add another Dock</u></a></span>");
            }  else if((numOfTopsIn - numOfTopsmDocks) >= 3) {
                 $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'><a class='addd' href='#'><img class='imgside' src='//foreverspin.com/cdn/shop/t/69/assets/ssds_compact.png?v=64711539300718695981763937062' alt='top'>Perhaps another <strong>ForeverDock&trade;</strong><br><u>Click to add another Dock</u></a></span>");
             } else if(isDockIn && numOfTops <= 5 && atLeastOneTop && !isPopular && !isPack) {
                $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'><a class='addt' href='#'><img class='imgside' src='//foreverspin.com/cdn/shop/t/69/assets/tinobg_small.png?v=2575924051852192451763937065' alt='top'></a>Your dock"+docks+" can hold <strong>"+ (numOfTops) +" more tops</strong><br><a class='addt' href='#'><u>Add our most popular Top</u></a></span>");
                if(numOfTops === 0){
                    $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'><img class='imgside' src='//foreverspin.com/cdn/shop/t/69/assets/tinobg_small.png?v=2575924051852192451763937065' alt='top'><strong>Titanium</strong> is the world’s favorite top<br/><a class='addt' href='#'>Click to add ForeverSpin&trade; Titanium</a></span>");
                } 
            } else if(isDockIn  && numOfTops <= 5 && atLeastOneTop) {
                $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'>Your display dock"+docks+" can hold <strong>"+ (numOfTops) +" more tops</strong></span>");
                if(numOfTops === 0){
                    $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'></span>");
                } 
            } else if(isDockIn && !isPopular && !isPack) {
                $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'><a class='addt' href='#'><img class='imgside' src='//foreverspin.com/cdn/shop/t/69/assets/tinobg_small.png?v=2575924051852192451763937065' alt='top'></a>Your dock"+docks+" can hold <strong>"+ (numOfTops) +" more tops</strong><br><a class='addt' href='#'><u>Add our most popular Top</u></a></span>");
                if(numOfTops === 0){
                    $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'><a class='addt' href='#'><img class='imgside' src='//foreverspin.com/cdn/shop/t/69/assets/tinobg_small.png?v=2575924051852192451763937065' alt='top'><strong>Titanium</strong> is the world’s favorite top<br/><u>Click to add a Titanium Top</u></a></span>");
                } 
            } else if(isDockIn) {
                $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'>Your display dock"+docks+" can hold <strong>"+ (numOfTops) +" more tops</strong></span>");
                if(numOfTops === 0){
                    $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'></span>");
                } 
            }  else if(!isPopular && !isPack) {
            $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'><a class='addt' href='#'><img class='imgside' src='//foreverspin.com/cdn/shop/t/69/assets/tinobg_small.png?v=2575924051852192451763937065' alt='top'><strong>Titanium</strong> is the world’s favorite top<br/><u>Click to add a Titanium Top</u></a></span>");
            } 
        }}
        else {
            $(".cart_quantity .cart_empty").empty();
            $(".freeshipingtext").css("display", "block");
        }
        $(".product-rows").html(html);
                  var dtotal= (total*0.80);
                 var dftotal= dtotal.toFixed(2);
        $(".payment-title > .total-price").html("$" + dftotal);
                  
                  
                  
    }    
    // End Of Code! Importent! Replace this code with the displayit() function in the original file!

    var x;


    if (typeof (Storage) !== "undefined") {
        var items = JSON.parse(SessionStorage.getItem("items"));
        if (items == null || items == '') {
            $(".product-rows").html("");
        } else {
            // 8. Eliran Code : Add this line, updates cartStatus
            cartStatus(items);
            // End of code
            displayit(items);
        }
    }



    $(".product-rows").on("click", '.removeit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var items = JSON.parse(SessionStorage.getItem("items"));
        var pid = $(this).data("id");
        var isexist = checkAlreadyExist(items, pid);
        if (isexist != -1) {
            var item = items[isexist];
            items[isexist] = ({id: pid, q: 0, p: item.p, n: item.n, gim: item.gim, catid: item.catid});
        }
        SessionStorage.setItem("items", JSON.stringify(items));
        var items = JSON.parse(SessionStorage.getItem("items"));
        refreshitembox();
        updatecart();
        // 9. Eliran Code : Add this line, updates cartStatus
        cartStatus(items);
        // End of code
        displayit(items);
    });



    function refresh() {
        var items = JSON.parse(SessionStorage.getItem("items"));
        var qu = 0;
        for (key in items) {
            if (!items[key])
                continue;
            qu += items[key].q;
        }
        if (qu > 0) {
            $("#gotocheckout").addClass("active");
        } else {
            $("#gotocheckout").removeClass("active");
        }
    }
    refresh();

    $("#addBase").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {0: 31437930823733};
        for (key in prods) {
            $("#" + prods[key] + " .quantity").find(".qplus").trigger("click");
        }
        ga('ec:addPromo', {
  'id': 'PROMO_basebanner',
  'name': 'Add Base Banner',
  'creative': 'text',
  'position': 'body'
});

ga('ec:setAction', 'promo_click');
ga('send', 'event', 'Internal Promotions', 'click', 'Add Base Banner');
      

    
      
      
      
    });
              
              
              $("#addDock").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {0: 6634492164};
        for (key in prods) {
            $("#" + prods[key] + " .quantity").find(".qplus").trigger("click");
        }
        ga('ec:addPromo', {
  'id': 'PROMO_dockbanner',
  'name': 'Add Dock Banner',
  'creative': 'text',
  'position': 'body'
});

ga('ec:setAction', 'promo_click');
ga('send', 'event', 'Internal Promotions', 'click', 'Add Dock Banner');
 
    
      
      
      
    });


        $('body').on('click', '.addb', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {0: 31437930823733};
        for (key in prods) {
            $("#" + prods[key] + " .quantity").find(".qplus").trigger("click");
        }
        ga('ec:addPromo', {
  'id': 'PROMO_base',
  'name': 'Add Base',
  'creative': 'textandimage',
  'position': 'cart'
});

ga('ec:setAction', 'promo_click');
ga('send', 'event', 'Internal Promotions', 'click', 'Add Base');
    });


    $('body').on('click', '.addtb', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {0: 6634492484, 1: 31437930823733};
        for (key in prods) {
            $("#" + prods[key] + " .quantity").find(".qplus").trigger("click");
        }
 ga('ec:addPromo', {
  'id': 'PROMO_baseandtop',
  'name': 'Add Base and Top',
  'creative': 'textandimage',
  'position': 'cart'
});

ga('ec:setAction', 'promo_click');
ga('send', 'event', 'Internal Promotions', 'click', 'Add Base and Top');


    });

              
              
               $("#addnt").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {0: 42834684543029};
        for (key in prods) {
            $("#" + prods[key] + " .quantity").find(".qplus").trigger("click");
        }
 ga('ec:addPromo', {
  'id': 'PROMO_populartop',
  'name': 'Add Popular Top',
  'creative': 'textandimage',
  'position': 'cart'
});

ga('ec:setAction', 'promo_click');
ga('send', 'event', 'Internal Promotions', 'click', 'Add New Top');

    });
              
              
              
              

        $('body').on('click', '.addt', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {0: 6634492484};
        for (key in prods) {
            $("#" + prods[key] + " .quantity").find(".qplus").trigger("click");
        }
 ga('ec:addPromo', {
  'id': 'PROMO_populartop',
  'name': 'Add Popular Top',
  'creative': 'textandimage',
  'position': 'cart'
});

ga('ec:setAction', 'promo_click');
ga('send', 'event', 'Internal Promotions', 'click', 'Add Popular Top');

    });


      $('body').on('click', '.addd', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {0: 6634492164};
        for (key in prods) {
            $("#" + prods[key] + " .quantity").find(".qplus").trigger("click");
        }
         ga('ec:addPromo', {
  'id': 'PROMO_dock',
  'name': 'Add Dock',
  'creative': 'textandimage',
  'position': 'cart'
});

ga('ec:setAction', 'promo_click');
ga('send', 'event', 'Internal Promotions', 'click', 'Add Dock');
    });


    var ispost = false;


    var total = 0;
    var sum = 0;
    var items = JSON.parse(SessionStorage.getItem("items"));

    for (n in items) {
        if (items[n] && items[n].q > 0) {
            total += items[n].p * items[n].q;
            sum += parseInt(items[n].q);
        }
    }

    if (parseInt(total) == 0) {
        $(".cart_quanity1").html('');
        $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'>Your cart is empty. <strong>Spend $89</strong> for free shipping<br/><a class='allproductss' href='#'>Add our Starter Pack!</a></span>");
    }
});



$( "#giftcheck" ).click(function() {

  ga('ec:addPromo', {
  'id': 'PROMO_enterstore',
  'name': 'Enter Store',
  'creative': 'menu',
  'position': 'cart'
});

ga('ec:setAction', 'promo_click');
ga('send', 'event', 'Internal Promotions', 'click', 'Enter Store');



});

var xhr;
function updatecart() {
    var items = JSON.parse(SessionStorage.getItem("items"));
    var parmas = {};
    for (key in items) {
        parmas[items[key]['id']] = items[key]['q'];
    }
    if (xhr && xhr.readystate != 4) {
        xhr.abort();
    }
    xhr = jQuery.ajax({url: '/cart/update.js', type: "post", dataType: "json", data: {updates: parmas}, success: function (data) {
        }});
}
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};



discount = getUrlParameter('discount');
if (discount != null) {
    if (typeof (Storage) !== "undefined") {
        SessionStorage.setItem("discount", discount);
    }
}



if (SessionStorage.getItem("discount") !== null) {

    var discount = "BLACKFRIDAY";

    if (discount != '[]') {
        $('#gotocheckout').each(function () {
            this.href += '?discount=' + discount;
        })
    }

    if ($("#discount_input").length && discount != '[]') {

        $("#discount_input").val(SessionStorage.getItem("discount"));
        document.cookie = "discount=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
        console.log(SessionStorage.getItem("discount"), "have");

    } else {
        $("#discount_input").remove();
    }
}



$(document).ready(function ($) {


    if ($("#breakPoint").length) {
        var doclength = $("#breakPoint").offset().top;
        var winheight = $(window).height();
        var wintop = $(window).scrollTop();
    }

    $(window).resize(function () {
        if ($("#breakPoint").length) {
            doclength = $("#breakPoint").offset().top;
            winheight = $(window).height();
            wintop = $(window).scrollTop();
        }
    });
    $(window).load(function () {
        if ($("#breakPoint").length) {
            doclength = $("#breakPoint").offset().top;
            $(window).on("scroll", function () {
                winheight = $(window).height();
                wintop = $(window).scrollTop();

                if ((wintop + winheight - 108) >= doclength) {
                    if ($(".cart-area").hasClass("stick") == false) {
                        $("#breakPoint").css({"padding-bottom": 0});
                        $(".product-rows").show();
                        $(".cart-area").addClass("stick");
                        $(".copyright").show();
                    }
                } else {
                    if ($(".cart-area").hasClass("stick") == true) {
                        $("#breakPoint").css({"padding-bottom": 150});
                        $(".cart-area").removeClass("stick");
                        $(".product-rows").hide();
                        $(".copyright").hide();
                    }
                }
            });
        }
    });
});
      
      $(document).ready(function ($) {
 $(".weight").click(function(){
        $("p", this).toggle(300);
       $( "i", this).toggleClass('fa-chevron-up fa-chevron-down');
       $( ".weight").toggleClass('active');
    });
});